import React, {useEffect} from 'react';
import {RcbToggleChatWindowEvent} from 'react-chatbotify';
import classNames from 'classnames';
import {useAnimationsContext} from '../../../contexts';
import styles from './HelloImage.module.scss';

interface HelloImageProps extends Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
}

const HelloImage = ({className, ...props}: HelloImageProps) => {
  const {animationDuration, animations} = useAnimationsContext();

  useEffect(() => {
    if (animations.hello.isOpen) {
      setTimeout(animations.hello.hide, animationDuration);
    }
  }, [animations.hello.isOpen]);

  useEffect(() => {
    const handleToggleChatWindow = (event: RcbToggleChatWindowEvent) => {
      if (event.data.newState) {
        animations.hello.show();
      } else {
        animations.hello.hide();
      }
    };

    window.addEventListener('rcb-toggle-chat-window', handleToggleChatWindow);
    return () => {
      window.removeEventListener('rcb-toggle-chat-window', handleToggleChatWindow);
    };
  }, []);

  return animations.hello.isOpen && (
    <img src={animations.hello.image} alt="hello" className={classNames(styles.image, className)} {...props} />
  );
};

export default HelloImage;